import React from 'react';
import styled from 'styled-components';
import { format } from 'date-fns';

const Wrapper = styled.div`
  font-family: sans-serif;
  font-size: 0.9rem;
`;

const Label = styled.div`
  font-family: Inter;
  font-weight: 400;
  font-size: 14px;
  color: var(--Body, #2a2929);
`;

const RangeContainer = styled.div`
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem 1rem;
  gap: 1.5rem;
  margin-top: 5px;
  box-shadow: 0px 0px 8px 0px #a2a2a23d;
`;

const RangeBlock = styled.div`
  font-family: Open Sans;
  font-weight: 400;
  font-size: 15px;
  color: var(--Input-field, #636363);
`;

const VS = styled.span`
  // font-family: Montserrat;
  font-weight: 500;
  font-size: 16px;
  color: #000000;
`;

const TimeRangeDisplay = ({ topic1, topic2 }) => {
  const formatDate = (date) => format(new Date(date), 'dd/MM/yyyy');

  return (
    <Wrapper>
      <Label>Selected Time Ranges</Label>
      <RangeContainer>
        <RangeBlock>
          {formatDate(topic1.from)} - {formatDate(topic1.to)}
        </RangeBlock>
        <VS>vs</VS>
        <RangeBlock>
          {formatDate(topic2.from)} - {formatDate(topic2.to)}
        </RangeBlock>
      </RangeContainer>
    </Wrapper>
  );
};

export default TimeRangeDisplay;
